import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {IStatus, Status} from '../models/status.model';
import {PaymentInfo} from "../models/payment.info";
@Injectable({
  providedIn: 'root'
})
export class PaytechService {

  constructor(private http: HttpClient) { }
  requestPayment(paymentInfo: PaymentInfo) {
    return this.http.post<any>(`${environment.url}/paytech/startRequestPayment`, paymentInfo);
  }
}
